import React, { useEffect } from "react"
import Aos from "aos"
import cardStyle from "./Card.module.css"
import "aos/dist/aos.css"

export default function Card(props) {
  const { align, cardTxt, cardImg } = props.propsData
  useEffect(() => {
    Aos.init({})
  }, [])

  return (
    <div
      className={`${cardStyle.card}  ${
        align === "alignLeft" ? cardStyle.flexRow : cardStyle.flexRowReverse
      }`}
      data-aos="zoom-in"
      data-aos-duration="1000"
    >
      <div
        className={cardStyle.cardImg}
        data-aos={`${align === "alignLeft" ? "flip-right" : "flip-left"}`}
        data-aos-duration="1200"
      >
        <img src={cardImg} alt="Event Poster" />
      </div>
      <div className={cardStyle.cardTxt}>{cardTxt}</div>
    </div>
  )
}
